export default {
    TextPlaceholder: '请输入审批意见',
    SettingTips: '设置为常用评审',
    SelectPlaceholder: '点击选择',
    UploadTitle: '点击或拖拽附件上传',
    OverSize: '超过规定大小',
    OverNum: '超过规定数量',
    success: '文件上传成功',
    error: '文件上传失败'
};
